import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaskitoOptions } from '@maskito/core';
import { MaskitoDirective } from '@maskito/angular';
import { DateConversionUtils } from '../../../utils/date-conversion-utils';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  standalone: true,
  imports: [MaskitoDirective],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DateInputComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() controlId: string | null = null;
  @Input() error: boolean = false;

  @Output() valueChanged = new EventEmitter<string | null>();

  @ViewChild('input', { static: true }) input!: ElementRef<HTMLInputElement>;

  public disabled: boolean = false;
  public value: string | null = null;

  public maskitoOptions: MaskitoOptions = {
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };

  public onChange = (_: any) => {};
  public onTouched = () => {};

  public handleInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value = inputValue;
    this.onChange(inputValue);
    this.valueChanged.emit(inputValue);
  }

  public writeValue(obj: any): void {
    if (!!obj) {
      const [day, month, year] = obj.split('/');
      const date = new Date(+year, +month - 1, +day);
      this.value = DateConversionUtils.dateToShorthand(date);
    } else {
      this.value = null;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
